import { useState } from "react";
import { competenciaAtual, somarMeses } from "@bookdental/schemas";
import { trpc } from "@/lib/trpc";
import { SeletorDeMes } from "@/components/financeiro/SeletorDeMes";
import type { Ocupacao } from "./formato";
import { IndicadoresDaOcupacao } from "./IndicadoresDaOcupacao";
import { OcupacaoPorSala } from "./OcupacaoPorSala";
import { MapaDeCalor } from "./MapaDeCalor";
import { UsoPorProfissional } from "./UsoPorProfissional";

/** As cadeiras estão sendo bem usadas? Agendado contra real, atrasos, ociosidade e horários cheios. */
export function AbaOcupacao() {
  const [competencia, setCompetencia] = useState(competenciaAtual());
  const atual = trpc.salas.ocupacao.useQuery({ competencia });
  const anterior = trpc.salas.ocupacao.useQuery({ competencia: somarMeses(competencia, -1) });
  const o = atual.data as Ocupacao | undefined;

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-xs text-zinc-500 dark:text-muted-foreground">O uso real só conta atendimentos iniciados e encerrados pelo botão de atendimento.</p>
        <SeletorDeMes valor={competencia} onChange={setCompetencia} />
      </div>
      {atual.isLoading || !o ? (
        <div className="grid gap-4 lg:grid-cols-2">
          {[0, 1].map((i) => (
            <div key={i} className="h-64 animate-pulse rounded-xl bg-zinc-100 dark:bg-muted" />
          ))}
        </div>
      ) : o.total.consultas === 0 && o.total.faltas === 0 && o.total.canceladas === 0 ? (
        <p className="rounded-xl border border-dashed border-zinc-300 px-6 py-14 text-center text-sm text-zinc-500 dark:border-border dark:text-muted-foreground">
          Sem consultas com sala neste mês.
        </p>
      ) : (
        <>
          <IndicadoresDaOcupacao atual={o} anterior={anterior.data as Ocupacao | undefined} />
          <div className="grid items-start gap-4 lg:grid-cols-2">
            <OcupacaoPorSala salas={o.salas} competencia={competencia} />
            <UsoPorProfissional ocupacao={o} />
          </div>
          <MapaDeCalor mapa={o.mapaDeCalor} />
        </>
      )}
    </div>
  );
}
